import { useEffect, useState } from "react";
import { Card, Col, Row } from "react-bootstrap";

function Github() {
  const username = "arpitsharma6074";
  const ghChartUrl = `https://ghchart.rshah.org/${username}`;
  const [ghProfile, setGhProfile] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchGithubProfile = async () => {
      try {
        const response = await fetch(`https://api.github.com/users/${username}`);
        const data = await response.json();
        setGhProfile(data);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching GitHub profile:", error);
        setLoading(false);
      }
    };

    fetchGithubProfile();
  }, []);

  return (
    <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
      <h1 className="project-heading" style={{ paddingBottom: "20px" }}>
         <strong className="purple">GitHub</strong>
      </h1>

      <Col md={10}>
        <Card style={{ backgroundColor: "#495057", border: "1px solid #c770f0" }}>
          <Card.Body>
            {/* GitHub Profile Header */}
            {ghProfile && (
              <div style={{ display: "flex", alignItems: "center", marginBottom: "20px" }}>
                <img
                  src={ghProfile.avatar_url}
                  alt={username}
                  style={{
                    width: "80px",
                    height: "80px",
                    borderRadius: "50%",
                    marginRight: "20px",
                    border: "2px solid #c770f0",
                  }}
                />
                <div>
                  <h3 style={{ color: "#c770f0", margin: "0" }}>
                    {ghProfile.name || username}
                  </h3>
                  <p style={{ color: "white", margin: "5px 0" }}>
                    @{ghProfile.login}
                  </p>
                  <p style={{ color: "#ccc", margin: "5px 0" }}>
                    {ghProfile.bio}
                  </p>
                </div>
              </div>
            )}

            {/* GitHub Stats */}
            {ghProfile && (
              <Row style={{ marginBottom: "20px", textAlign: "center" }}>
                <Col xs={4}>
                  <p style={{ color: "#c770f0", fontSize: "18px", fontWeight: "bold" }}>
                    {ghProfile.public_repos}
                  </p>
                  <p style={{ color: "white", fontSize: "14px" }}>Repositories</p>
                </Col>
                <Col xs={4}>
                  <p style={{ color: "#c770f0", fontSize: "18px", fontWeight: "bold" }}>
                    {ghProfile.followers}
                  </p>
                  <p style={{ color: "white", fontSize: "14px" }}>Followers</p>
                </Col>
                <Col xs={4}>
                  <p style={{ color: "#c770f0", fontSize: "18px", fontWeight: "bold" }}>
                    {ghProfile.following}
                  </p>
                  <p style={{ color: "white", fontSize: "14px" }}>Following</p>
                </Col>
              </Row>
            )}

            {/* Contribution Chart */}
            <a
              href={`https://github.com/${username}`}
              target="_blank"
              rel="noopener noreferrer"
              style={{ display: "block", textAlign: "center" }}
            >
              <img
                src={ghChartUrl}
                alt={`${username} github contributions`}
                style={{ maxWidth: "100%", height: "auto", marginTop: "20px" }}
              />
            </a>
          </Card.Body>
        </Card>
      </Col>
    </Row>
  );
}

export default Github;
